module.exports = __webpack_public_path__ + "static/media/480.6d210eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-stones/light/480.png
// module id = 2490
// module chunks = 2